












    import Vue from 'Vue';

    export default Vue.extend({
        name:'error-snackbar',
        data(): any {
            return { show: false, message: '', timeout: -1 }
        },
        created (): void {
            this.$store.watch(state => state.ui.errorMessage,
                () => {
                    const msg = this.$store.state.ui.errorMessage;
                    this.message = msg;
                    if (msg !== '') {
                        this.show = true;
                    } else {
                        this.show = false;
                    }
                });
        },
        methods: {
            closeClicked() {
                this.$store.commit('ui/setErrorMessage','');
            }
        },
        computed: {
            btnTextClose(): string { return this.$vuetify.lang.t('webmap.buttonText.close') }
        }
    });
